import React, { useState, useEffect } from 'react';
import { Row, Col, Typography, Space, Input, Select, Button, Empty, Carousel, Tag } from 'antd';
import { SearchOutlined, FilterOutlined, AppstoreOutlined, TagsOutlined } from '@ant-design/icons';
import PostCard from '../../components/PostCard';
import { getAllPosts } from '../../api/mockData'; // 更新导入
import { posts } from '../../api/mockData'; // 保留原始数据
import './Home.css';

const { Title, Text } = Typography;
const { Search } = Input;

const Home = () => {
  const [allPosts, setAllPosts] = useState([]); // 从localStorage获取的文章
  const [filteredPosts, setFilteredPosts] = useState([]); // 过滤后的文章
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTag, setSelectedTag] = useState('');

  // 获取所有文章（包括localStorage中的新文章）
  useEffect(() => {
    const storedPosts = getAllPosts(); // 从localStorage获取文章
    setAllPosts(storedPosts);
    setFilteredPosts(storedPosts); // 初始时显示所有文章
  }, []);

  // 获取所有唯一标签
  const allTags = [...new Set(allPosts.flatMap(post => post.tags || []))];

  // 过滤文章
  useEffect(() => {
    let result = allPosts;
    
    if (searchTerm) {
      result = result.filter(post => 
        post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        post.excerpt.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    if (selectedTag) {
      result = result.filter(post => 
        post.tags && post.tags.includes(selectedTag)
      );
    }
    
    setFilteredPosts(result);
  }, [searchTerm, selectedTag, allPosts]);

  // 轮播图数据 - 可以展示热门文章
  const carouselPosts = allPosts.slice(0, 3);

  return (
    <div className="home-page">
      {/* 轮播图区域 - 展示热门文章 */}
      <div className="hero-section" style={{ marginBottom: 32 }}>
        <Carousel autoplay style={{ borderRadius: 8, overflow: 'hidden' }}>
          {carouselPosts.map((post, index) => (
            <div key={index} style={{ padding: '40px', background: '#fff', textAlign: 'center' }}>
              <Title level={2}>{post.title}</Title>
              <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
                {post.excerpt.substring(0, 100)}...
              </Text>
              <Space wrap>
                {post.tags && post.tags.map((tag, idx) => (
                  <Tag key={idx} color="blue">{tag}</Tag>
                ))}
              </Space>
            </div>
          ))}
        </Carousel>
      </div>

      <div className="header-section" style={{ marginBottom: 32 }}>
        <Title level={1}>Qmau的博客</Title>
        <Text type="secondary" style={{ fontSize: '16px' }}>记录生活，分享知识</Text>
      </div>

      <div className="filters-section" style={{ marginBottom: 24 }}>
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} md={12}>
            <Search
              placeholder="搜索文章..."
              allowClear
              enterButton="搜索"
              size="large"
              prefix={<SearchOutlined />}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ borderRadius: 6 }}
            />
          </Col>
          <Col xs={24} md={8}>
            <Select
              placeholder="选择标签"
              allowClear
              style={{ width: '100%', borderRadius: 6 }}
              size="large"
              onChange={setSelectedTag}
              options={allTags.map(tag => ({ label: tag, value: tag }))}
              prefix={<TagsOutlined />}
            />
          </Col>
          <Col xs={24} md={4}>
            <Button 
              type="default" 
              size="large" 
              block
              onClick={() => {
                setSearchTerm('');
                setSelectedTag('');
              }}
            >
              重置
            </Button>
          </Col>
        </Row>
      </div>

      <div className="posts-section">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <Title level={3} style={{ margin: 0 }}>
            文章列表 <Text type="secondary" style={{ fontSize: '14px' }}>({filteredPosts.length} 篇)</Text>
          </Title>
        </div>
        
        {filteredPosts.length > 0 ? (
          <Row gutter={[24, 24]}>
            {filteredPosts.map(post => (
              <Col xs={24} sm={12} lg={8} key={post.id}>
                <PostCard post={post} />
              </Col>
            ))}
          </Row>
        ) : (
          <div style={{ textAlign: 'center', padding: '40px 0' }}>
            <Empty 
              description="没有找到相关文章"
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;